<template>
    <div class="mt-3">
        <div class="lead">{{$t('question.finished.leadMessage')}}</div>
        <div class="mt-2" v-if="unansweredCount">{{$t('question.finished.unansweredMessage', [unansweredCount])}}</div>
        <div class="mt-3">
            <router-link v-if="unansweredCount"
                         :to="{ name: 'UserAnswerSkippedList'}"
                         class="btn btn-default">{{$t('question.finished.unansweredLink')}}
            </router-link>
            <br>
            <router-link :to="{ name: 'UserAnswerList' }" class="btn btn-default">
                {{$t('question.finished.myAnswers')}}
            </router-link>
            <br>
            <router-link :to="{ name: 'PackList' }" class="btn btn-default">{{$t('question.finished.allPacks')}}
            </router-link>
            <br>
            <!--<router-link :to="{ name: 'NextPack' }" class="btn btn-default">{{$t('question.finished.nextPack')}}</router-link><br>-->
        </div>
    </div>
</template>
<script>
    import {createNamespacedHelpers} from 'vuex';

    const {mapGetters} = createNamespacedHelpers('question/finished');
    export default {
        computed: mapGetters([
            'unansweredCount'
        ]),
        created() {
            this.$store.dispatch("question/finished/retrieve");
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/question/Finished.vue